import { Form, Input, Row, Col, Switch, InputNumber, AutoComplete } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const apiId = 'deviceType';
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();
    // 修复：必须给初始值 []，否则类型是 [] | undefined，下面 .map 会报 TS18048
    const [EMQXBrokerUrlData, setEMQXBrokerUrlData] = useState<any[]>([]);

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        })
        fetchApi.GET(getService('bm'), {
            query: {
                apiId: 'generalData',
                apiVariable: 'EMQXBrokerUrl',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { EMQXBrokerUrl } = res.data;
                setEMQXBrokerUrlData(EMQXBrokerUrl ?? []); // 兜底：接口没数据时给空数组
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        displayOptions: {
            width: 900
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={14}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id"
                                    tooltip="设备类型的唯一标识，由系统自动生成，创建后不可修改，通常仅用于系统内部关联与追溯。">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="类型名称"
                                    name="typeName"
                                    tooltip="设备类型的展示名称，用于在型号、设备等界面下拉选择与展示，建议填写简洁易懂的名称，如：传感器、网关、开关。"
                                    rules={[{ required: true, message: '类型名称!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="编码"
                                    name="code"
                                    tooltip="设备类型的唯一编码，用于程序识别与设备上报匹配，必须全局唯一，建议使用小写字母、数字和下划线，如：sensor、gateway。"
                                    rules={[{ required: true, message: '编码（唯一）!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="设备服务地址"
                                    name="serviceUrl"
                                    tooltip="设备的服务地址，会传给设备保存。可从下拉选择，也可手动输入。">
                                    <AutoComplete
                                        allowClear
                                        placeholder="设备服务地址（可选择或手动输入）"
                                        // AutoComplete 用 options 属性，不用 children
                                        options={(EMQXBrokerUrlData ?? []).map((item: any) => ({
                                            value: item.id,
                                            // label 决定下拉显示内容，value 决定真正存进表单的值
                                            label: `${item.name}｜${item.id}`
                                        }))}
                                        showSearch={{
                                            filterOption: (input, option: any) =>
                                                (option?.label ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="排序"
                                    name="sort"
                                    tooltip="列表展示时的排序权重，数值越小越靠前。用于调整设备类型在下拉/列表中的显示顺序，默认 0。">
                                    <InputNumber
                                        style={{ width: 130 }} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}
                                    tooltip="该设备类型是否启用。启用后可用于新增设备型号；关闭后不影响已关联数据，但不可再被新数据选择。">
                                    {/* 修复：去掉写死的 checked={true}，否则会覆盖表单托管的值 */}
                                    <Switch
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>
                        </Row>

                    </Col>
                    <Col span={10}>
                        <Form.Item
                            label=""
                            name="description"
                            tooltip="设备类型的详细描述信息，支持富文本编辑，可填写用途说明、适用场景、注意事项等内容，用于文档展示。">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`deviceType${id}`}
                                title='描述'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 400 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;